
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignFoundationsTypography',
  components: { DesignContentLayout }
};
